<template>
    <!-- 考试信息 -->
    <div>
        <div class="conditionSearchBox">
            <div class="conditionItem">
                <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.classname" placeholder="班级名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.classcoursename" placeholder="课程名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classcoursename" label="课程名称" align="center" width="150" key="classcoursename" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="qbname" label="考试名称" align="center" width="200" key="qbname" :formatter="formatTab" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p class="pointer color-brand text-ellipse" @click="openCorrect(scope.row)">{{scope.row.qbname}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="timneend" label="考试时间" align="center" width="250" key="timneend" :formatter="formatTab">
                <template slot-scope="scope">
                    <p>{{scope.row.timnestart + '~' + scope.row.timneend}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="statusname" label="考试状态" align="center" width="100" key="statusname"></el-table-column>
            <el-table-column prop="endtime" label="完成时间" align="center" width="200" key="endtime" :formatter="formatTab"></el-table-column>
            <el-table-column prop="score" label="考试分值" align="center" width="100" key="score" :formatter="formatTab"></el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        <Correct ref="Correct"></Correct>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getCourseExamList } from '@/api/measApi/studentManage.js'
import Correct from '@/views/meas/teachManagement/components/correct.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          classcode: '',
          classcoursecode: '',
          classcoursename: '',
          classname: '',
          infotype: 1, // 0作业 1 考试
          periodcode: '',
          periodname: '',
          periodtiemend: '',
          periodtiemstart: '',
          status: '',
          studentcode: '',
          studentname: ''
        },
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      contentLoading: false,
      tableData: [],
      total: 0,
      isSelect: false,
      date: []
    }
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  components: {
    TableSort,
    Page,
    Correct
  },
  created() {
    this.params.condition.studentcode = this.code
    this.getCourseExamList()
  },
  methods: {
    //   获取作业列表
    getCourseExamList() {
      this.contentLoading = true
      if (this.date && this.date.length > 0) {
        this.params.condition.periodtiemstart = this.date[0]
        this.params.condition.periodtiemend = this.date[1]
      } else {
        this.params.condition.periodtiemend = ''
        this.params.condition.periodtiemstart = ''
      }
      getCourseExamList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getCourseExamList()
    },
    // 重置
    reset() {
      this.date = []
      this.params = {
        condition: {
          classcode: '',
          classcoursecode: '',
          classcoursename: '',
          classname: '',
          infotype: 1, // 0作业 1 考试
          periodcode: '',
          periodname: '',
          periodtiemend: '',
          periodtiemstart: '',
          status: '',
          studentcode: this.code,
          studentname: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getCourseExamList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getCourseExamList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getCourseExamList()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 打开作业详情
    openCorrect(row) {
      this.$refs.Correct.init(row.code, 1, false)
    }
  }
}
</script>
